import axios from '../axios'

/*
 * 字典管理模块
 */

/**
 * 根据服务上，查询车型列表
 * @param {*} data
 * type	是	string	固定值 course_source
    value	是	string	课程提供商字典中的value
 * @wiki  http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12060015  20220614
 */
export const listCarTypeByServiceProvider = data => {
  data = Object.assign(data, {
    type: data.type || 'course_source'
  })
  return axios({
    url: '/sysdict/listAll',
    method: 'post',
    data
  })
}

/**
 * 查询字典类型
 *  - 备注作为类型名称 
 * @returns 
 */
export const getDictTypeList = data => {
    return axios({
        url: '/sysdict/listRemark',
        method: 'post',
        data: {}
    })
}

// 保存
export const save = (data) => {
  return axios({
    url: '/sysdict/save',
    method: 'post',
    data
  })
}
// 删除
export const batchDelete = (data) => {
  return axios({
    url: '/sysdict/delete',
    method: 'post',
    data
  })
}
// 分页查询
export const findPage = (data) => {
  return axios({
    url: '/sysdict/list',
    method: 'post',
    data
  })
}
/**
 * 
 * @param {*} data
 * type 
 * @returns 
 */
export const getDicJson = (data) => {
  return axios({
    url: '/sysdict/listByType',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/dict.js